var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCicrcleIcon = function SvgCheckCicrcleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 2.278c-7.842 0-14.222 6.38-14.222 14.222S8.158 30.722 16 30.722s14.222-6.38 14.222-14.222S23.842 2.278 16 2.278m0 24.889c-5.883 0-10.667-4.784-10.667-10.667S10.117 5.833 16 5.833 26.667 10.617 26.667 16.5 21.883 27.167 16 27.167"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.222 21.833c-.455 0-.91-.174-1.257-.52L9.41 17.757a1.776 1.776 0 0 1 0-2.514 1.776 1.776 0 0 1 2.514 0l2.298 2.299 5.854-5.854a1.776 1.776 0 0 1 2.514 0 1.776 1.776 0 0 1 0 2.513l-7.11 7.111c-.348.347-.803.521-1.258.521"
  })));
};
export default SvgCheckCicrcleIcon;